/**
 * Espejo de apps/backend/src/modules/auth/permissions.ts. Solo mejora la experiencia
 * (oculta lo que no corresponde); la seguridad real la aplica el servidor.
 * Un test verifica que ambos archivos digan lo mismo.
 */
export const PERMISSIONS = {
    SALES_CREATE: 'sales.create',
    SALES_READ_OWN: 'sales.read_own',
    SALES_PAY: 'sales.pay',
    SALES_DOCUMENTS: 'sales.documents',
    SALES_INVOICE: 'sales.invoice',
    CASH_OPERATE: 'cash.operate',
    CATALOG_READ: 'catalog.read',
    CUSTOMERS_READ: 'customers.read',
    CUSTOMERS_CREATE: 'customers.create',
    POS_SETTINGS_READ: 'settings.pos_read',
    PAYMENTS_COLLECT: 'payments.collect',
    PARKED_MANAGE: 'parked.manage',
    PROFORMAS_MANAGE: 'proformas.manage',
    CATALOG_MANAGE: 'catalog.manage',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
export type Access = Permission | 'admin';

export const CASHIER_PERMISSIONS: readonly Permission[] = [
    PERMISSIONS.SALES_CREATE,
    PERMISSIONS.SALES_READ_OWN,
    PERMISSIONS.SALES_PAY,
    PERMISSIONS.SALES_DOCUMENTS,
    PERMISSIONS.SALES_INVOICE,
    PERMISSIONS.CASH_OPERATE,
    PERMISSIONS.CATALOG_READ,
    PERMISSIONS.CUSTOMERS_READ,
    PERMISSIONS.CUSTOMERS_CREATE,
    PERMISSIONS.POS_SETTINGS_READ,
    PERMISSIONS.PAYMENTS_COLLECT,
    PERMISSIONS.PARKED_MANAGE,
    PERMISSIONS.PROFORMAS_MANAGE,
    PERMISSIONS.CATALOG_MANAGE,
];

/** Falla cerrado: cualquier valor que no sea un rol conocido no tiene ningún permiso. */
export function roleHasPermission(role: string | undefined, permission: Permission): boolean {
    if (role === 'admin') return true;
    if (role === 'cajero') return CASHIER_PERMISSIONS.includes(permission);
    return false;
}

export function canAccess(role: string | undefined, access: Access): boolean {
    if (access === 'admin') return role === 'admin';
    return roleHasPermission(role, access);
}

export function homePathFor(role: string | undefined): string {
    return role === 'admin' ? '/dashboard' : '/sales';
}
